import { defineNuxtPlugin } from "#imports";

export default defineNuxtPlugin({
  name: "start",
  enforce: "pre", // or 'post'
  hooks: {
    // You can directly register Nuxt app runtime hooks here
    "app:error"(error) {
      console.error(error);
    },
  },
  env: {
    // Set this value to `false` if you don't want the plugin to run when rendering server-only or island components.
    islands: true,
  },
});
